import { queryKeys } from '@lib/queryKeys'
import type { ResourceType } from '@orbit/api-types'
import { QueryClient, QueryKey } from '@tanstack/react-query'

/** The query listing each kind of entity a file can hang off. */
const RESOURCE_KEYS: Partial<Record<ResourceType, (tripId: string) => QueryKey>> = {
	ACCOMMODATION: queryKeys.accommodations,
	TRIP_EVENT: queryKeys.events,
	IDEA: queryKeys.ideas,
	FLIGHT_GROUP: queryKeys.flights,
}

/**
 * Refetches what a file upload or delete changes: the trip's files, and the
 * entity the file hangs off, whose `fileIds` it is listed in.
 */
export const invalidateFileResource = (queryClient: QueryClient, tripId: string, resourceType?: ResourceType): void => {
	queryClient.invalidateQueries({ queryKey: queryKeys.files(tripId) })
	const resourceKey = resourceType && RESOURCE_KEYS[resourceType]
	if (resourceKey) queryClient.invalidateQueries({ queryKey: resourceKey(tripId) })
}
